import { MSelector } from '@argalis-apps/models';

export const TEST_IFamile_Group: MSelector.IFamile_Group_Site[] = [
  {
    id: '1',
    libelle: 'groupe 1'
  },
  {
    id: '2',
    libelle: 'groupe 2'
  },
  {
    id: '3',
    libelle: 'groupe 3'
  }
];

export const TEST_SITE: MSelector.IFamile_Group_Site[] = [
  {
    id: '1',
    libelle: 'ARGALIS - Bureaux BELZ'
  },
  {
    id: '2',
    libelle: 'ARGALIS - Formation à distance'
  },
  {
    id: '3',
    libelle: 'ARGALIS - Formation à distance'
  },
  {
    id: '4',
    libelle: 'ARGALIS - Siège Villeurbanne'
  }
];

export const TEST_ISector: MSelector.ISector[] = [
  {
    id: '7',
    libelle: 'Nouvel utilisateur',
    id_organisme_formation: '1'
  },
  {
    id: '8',
    libelle: 'Formation metier',
    id_organisme_formation: '1'
  }
];

export const TEST_IProduit: MSelector.IProduit[] = [
  {
    libelle_total: 'Formation nouvel utilisateur Argalis - 2 jours - E-learning',
    id: '180',
    actif_modalite: true,
    objectif_formation:
      'Cette formation a pour finalité de permettre au personnel formé d’utiliser l’ensemble des fonctionnalités de la solution Argalis en autonomie.',
    prix_catalogue_intra: 1700,
    prix_catalogue_inter: 0,
    libelle: 'Formation nouvel utilisateur Argalis - 2 jours',
    reference: 'PRO-000093',
    duree_h: 14,
    effectif_mini: 1,
    effectif_maxi: 4,
    libelle_modalite: 'E-learning',
    id_tva: '2',
    actif: true,
    points_forts:
      '+ EXERCICES SUR DES CAS CONCRETS + ATELIERS PRATIQUES SUR ORDINATEUR + ACQUISITION DE BONNES PRATIQUES',
    mentions: null,
    duree_j: 2,
    type_modalite: 2,
    habilitation: null,
    id_produit: '93'
  }
];
export const TEST_Sesson: MSelector.IStatut_Session[] = [
  { id: '1', libelle: 'Prévisionnel', couleur: 'statut-1', code: 'PREVI', id_organisme_formation: null },
  { id: '2', libelle: 'Confirmé', couleur: 'statut-2', code: 'CONF', id_organisme_formation: null },
  { id: '3', libelle: 'En cours', couleur: 'statut-3', code: 'COURS', id_organisme_formation: null },
  { id: '4', libelle: 'Terminé', couleur: 'statut-4', code: 'TERM', id_organisme_formation: null },
  { id: '5', libelle: 'Archivé', couleur: 'statut-6', code: 'ARCHI', id_organisme_formation: null },
  { id: '6', libelle: 'Annulé', couleur: 'statut-7', code: 'ANNULE', id_organisme_formation: null }
];

export const TEST_TYPE_APPRENANT: MSelector.ITypeApprenantSelector[] = [
  { id: '1', libelle: 'Salarié', code: 'PREVI' },
  { id: '2', libelle: "Personne en recherche d'emploi", code: 'PUBL' },
  { id: '3', libelle: 'Particulier', code: 'PART' },
  { id: '4', libelle: 'Autre', code: 'AUTRE' }
];
export const TEST_INTERVEANANTDEPARTEMEN: MSelector.IIntervenantDepartementsSelector[] = [
  { id: '4', libelle: 'Aisne', numero: '02' },
  { id: '5', libelle: 'Allier', numero: '03' },
  { id: '6', libelle: 'Alpes-de-Haute-Provence', numero: '04' },
  { id: '7', libelle: 'Hautes-Alpes', numero: '05' }
];
export const TEST_MOTIF_ABSENCE_SELECTOR: MSelector.IMotifAbsenceSelector[] = [
  {
    id: '5',
    libelle: 'Injustifiée',
    b_defaut: true
  },
  {
    id: '3',
    libelle: 'Arrêt de travail',
    b_defaut: null
  },
  {
    id: '4',
    libelle: 'Raison familliale',
    b_defaut: null
  },
  {
    id: '6',
    libelle: 'Abandon',
    b_defaut: null
  }
];
